export const entityConfigs = {
  page: {
    singular: 'page',
    plural: 'pages',
    singularLabel: 'Page',
    pluralLabel: 'Pages',

    api: {
      endpoints: {
        list: '/pages',
        single: '/pages/:id',
        create: '/pages',
        update: '/pages/:id',
        delete: '/pages/:id',
        publish: '/pages/:id/publish',
      },
      queryKeys: {
        single: 'page',
        list: 'pages',
      },
    },

    routes: {
      list: '/pages',
      builder: '/pages/:id/builder',
    },

    meta: {
      base: {
        title: '',
        slug: '',
        excerpt: '',
        meta_description: '',
        published_at: '',
        author_id: '',
        featured_image: '',
        allow_comments: false,
        is_published: false,
        categories: [],
      },
      specific: {
        is_homepage: false,
      },
    },

    fields: {
      required: ['title', 'slug', 'author_id'],

      sidebar: [
        {
          name: 'title',
          type: 'text',
          label: 'Title',
          icon: 'FileText',
          required: true,
          placeholder: 'Page title',
        },
        {
          name: 'slug',
          type: 'text',
          label: 'Slug',
          required: true,
          placeholder: 'page-slug',
        },
        {
          name: 'author_id',
          type: 'select',
          label: 'Author',
          icon: 'User',
          required: true,
          dataSource: 'users',
        },
        {
          name: 'published_at',
          type: 'datetime',
          label: 'Published At',
          icon: 'Calendar',
        },
        {
          name: 'excerpt',
          type: 'textarea',
          label: 'Excerpt',
          placeholder: 'Brief description',
          rows: 3,
        },
        {
          name: 'meta_description',
          type: 'textarea',
          label: 'Meta Description',
          placeholder: 'SEO meta description',
          rows: 3,
        },
        {
          name: 'categories',
          type: 'category-selector',
          label: 'Categories',
          icon: 'Tag',
        },
        {
          name: 'featured_image',
          type: 'image',
          label: 'Featured Image',
        },
        {
          type: 'divider',
        },
        {
          name: 'is_homepage',
          type: 'checkbox',
          label: 'Set as homepage',
          specific: true,
        },
      ],
    },

    blockField: 'page_id',
  },

  post: {
    singular: 'post',
    plural: 'posts',
    singularLabel: 'Post',
    pluralLabel: 'Posts',

    api: {
      endpoints: {
        list: '/posts',
        single: '/posts/:id',
        create: '/posts',
        update: '/posts/:id',
        delete: '/posts/:id',
        publish: '/posts/:id/publish',
      },
      queryKeys: {
        single: 'post',
        list: 'posts',
      },
    },

    routes: {
      list: '/posts',
      builder: '/posts/:id',
    },

    meta: {
      base: {
        title: '',
        slug: '',
        excerpt: '',
        meta_description: '',
        published_at: '',
        author_id: '',
        featured_image: '',
        allow_comments: true,
        is_published: false,
        categories: [],
      },
      specific: {},
    },

    fields: {
      required: ['title', 'slug', 'author_id'],

      sidebar: [
        {
          name: 'title',
          type: 'text',
          label: 'Title',
          icon: 'FileText',
          required: true,
          placeholder: 'Post title',
        },
        {
          name: 'slug',
          type: 'text',
          label: 'Slug',
          required: true,
          placeholder: 'post-slug',
        },
        {
          name: 'author_id',
          type: 'select',
          label: 'Author',
          icon: 'User',
          required: true,
          dataSource: 'users',
        },
        {
          name: 'published_at',
          type: 'datetime',
          label: 'Published At',
          icon: 'Calendar',
        },
        {
          name: 'excerpt',
          type: 'textarea',
          label: 'Excerpt',
          placeholder: 'Brief description',
          rows: 3,
        },
        {
          name: 'meta_description',
          type: 'textarea',
          label: 'Meta Description',
          placeholder: 'SEO meta description',
          rows: 3,
        },
        {
          name: 'categories',
          type: 'category-selector',
          label: 'Categories',
          icon: 'Tag',
        },
        {
          name: 'featured_image',
          type: 'image',
          label: 'Featured Image',
        },
      ],
    },

    blockField: 'post_id',
  },
  product: {
    singular: 'product',
    plural: 'products',
    singularLabel: 'Product',
    pluralLabel: 'Products',

    api: {
      endpoints: {
        list: '/ecommerce/products',
        single: '/ecommerce/products/:id',
        create: '/ecommerce/products',
        update: '/ecommerce/products/:id',
        delete: '/ecommerce/products/:id',
        publish: '/ecommerce/products/:id/publish',
      },
      queryKeys: {
        single: 'product',
        list: 'products',
      },
    },

    routes: {
      list: '/products',
      builder: '/products/:id',
    },

    meta: {
      base: {
        sku: '',
        type: 'simple',
        status: 'draft',
        is_featured: false,
        name: '',
        slug: '',
        short_description: '',
        description: '',
        price: '',
        compare_at_price: '',
        track_inventory: true,
        stock_quantity: 0,
        low_stock_threshold: 5,
        allow_backorders: false,
        featured_image: '',
        meta_title: '',
        meta_description: '',
        tax_class: 'standard',
        weight: '',
        categories: [],
        template_id: null,
      },
      specific: {},
    },

    fields: {
      required: ['name', 'slug', 'sku', 'price'],
      sidebar: [],
    },

    blockField: 'product_id',
  },
  template: {
    singular: 'template',
    plural: 'templates',
    singularLabel: 'Template',
    pluralLabel: 'Templates',

    api: {
      endpoints: {
        list: '/content-templates',
        single: '/content-templates/:id',
        create: '/content-templates',
        update: '/content-templates/:id',
        delete: '/content-templates/:id',
        publish: null,
      },
      queryKeys: {
        single: 'content-template',
        list: 'content-templates',
      },
    },

    routes: {
      list: '/templates',
      builder: '/templates/:id',
    },

    meta: {
      base: {
        name: '',
        description: '',
        thumbnail: '',
        target_entity_type: 'product',
        is_active: true,
        sync_blocks: true,
        sort_order: 0,
      },
      specific: {},
    },

    fields: {
      required: ['name', 'target_entity_type'],
      sidebar: [],
    },

    blockField: 'content_template_id',
  },
}

export const getEntityConfig = (entityType) => {
  const config = entityConfigs[entityType]
  if (!config) {
    throw new Error(`Unknown entity type: ${entityType}`)
  }
  return config
}

export const getInitialMeta = (entityType) => {
  const config = getEntityConfig(entityType)
  return {
    ...config.meta.base,
    ...config.meta.specific,
  }
}
